import { render, staticRenderFns } from "./DaysOffList.vue?vue&type=template&id=175b45bd&"
import script from "./DaysOffList.vue?vue&type=script&lang=js&"
export * from "./DaysOffList.vue?vue&type=script&lang=js&"
import style0 from "./DaysOffList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DaysOffList.vue"
export default component.exports